import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import TaxEditorFields from "../TaxEditorFields/TaxEditorFields";
import FormWithButtons from "../FormWithButttons/FormWithButtons";
import DiscountsEditorFields from "../DiscountsEditorFields/DiscountsEditorFields";

const initialFormValues = {
  selectedTax: undefined,
  selectedTariff: undefined,
  totalPrice: 0,
  discountsList: [],
};

function TaxesAndDiscountsEditor({ defaultValues, onCancel, onSubmit }) {
  const [formValues, setFormValues] = useState(initialFormValues);

  const handleTaxValuesChange = ({ inputName, inputValue }) => {
    setFormValues(prev => ({ ...prev, [inputName]: inputValue }));
  };
  const handleCancel = () => {
    onCancel?.();
  };
  const handleSubmit = () => {
    const { discountsList, selectedTariff, selectedTax } = formValues;
    const discountAmountsList = discountsList.map(discount => discount.Percent);
    onSubmit?.({
      selectedTariff,
      selectedTax,
      discountsList: discountAmountsList,
    });
  };

  return (
    <Box
      sx={{
        minWidth: "488px",
        padding: "30px 18px",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ width: "24px", height: "24px", padding: "4px" }}
          onClick={handleCancel}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </Box>
      <Typography fontSize={16} fontWeight={600} variant="h3">
        Editar impuestos
      </Typography>
      <TaxEditorFields
        taxesFormValues={{
          tariffId:
            formValues.selectedTariff?.id || defaultValues.selectedTariffId,
          taxId: formValues.selectedTax?.id || defaultValues.selectedTaxId,
        }}
        onSelectChange={handleTaxValuesChange}
      />
      <Typography fontSize={16} fontWeight={600} variant="h3">
        Agregar descuentos
      </Typography>
      <DiscountsEditorFields
        defaultDiscounts={defaultValues.percentageDiscountsList || []}
        discountsList={formValues.discountsList || []}
        productTotal={defaultValues.totalPrice}
        onDiscountsListChange={newDiscountsList =>
          setFormValues(prev => ({
            ...prev,
            discountsList:
              typeof newDiscountsList === "function"
                ? newDiscountsList(prev.discountsList)
                : newDiscountsList,
          }))
        }
      />
      <FormWithButtons
        buttonsAlignment="end"
        submitText="Guardar"
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    </Box>
  );
}

TaxesAndDiscountsEditor.propTypes = {
  defaultValues: PropTypes.shape({
    selectedTariffId: PropTypes.number.isRequired,
    selectedTaxId: PropTypes.number.isRequired,
    totalPrice: PropTypes.number,
    percentageDiscountsList: PropTypes.array,
  }),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};
TaxesAndDiscountsEditor.defaultProps = {
  defaultValues: undefined,
  onCancel: undefined,
  onSubmit: undefined,
};

export default TaxesAndDiscountsEditor;
